import { addImposterToUrl } from 'Utils';
import { api } from './axios';

const baseURL = '/DisabilityConfirmations';

export interface IDisabilityConfirmation {
  title: string;
  description: string;
  attachmentId: number;
  disabilityName: string;
  linkInformation: string;
  link: string;
}

export const getDisabilityConfirmations = async () => {
  const paymentAndDeductions = await api.get<IDisabilityConfirmation[]>(
    addImposterToUrl(`${baseURL}`, true)
  );
  if (paymentAndDeductions.data) return paymentAndDeductions.data;
};

export const getDisabilityConfirmationPdf = async (id: number) => {
  const disabilityConfirmationPdf = await api.get<any>(
    addImposterToUrl(`${baseURL}/${id}`, true)
  );
  if (disabilityConfirmationPdf.data) return disabilityConfirmationPdf.data;
};
